import ProjectInitiationForm from './forms/step1/ProjectInitiationForm';
import ProjectFormHeader from './forms/common/ProjectFormHeader';
import { useNavigate } from 'react-router-dom';
import { useInitProjectQueryParams } from './forms/step2/useInitProjectQueryParams';
import ProjectToolsForm from './forms/step2/ProjectToolsForm';
import { PROJECT_STATE, useNewProjectService, useNewProjectUrl } from 'domain/shared/newProject';

const CreateProjectLayout = () => {
  const { currentStep, initProjectState, toolsProjectState } = useInitProjectQueryParams();

  const navigate = useNavigate();

  const { patchProjectInfo } = useNewProjectService();
  const { getSingleEntityUrl } = useNewProjectUrl();

  return (
    <>
      <ProjectFormHeader currentStep={currentStep} />
      {currentStep === 1 && (
        <ProjectInitiationForm
          urlParams={initProjectState}
          afterSubmit={{
            redirect: result => {
              if (result.shouldRedirectToTools) {
                const params = new URLSearchParams({
                  step: (currentStep + 1).toString(),
                  projectId: result.projectId,
                  ...(result.relatedProjectId && { relatedProjectId: result.relatedProjectId }),
                });
                return `?${params.toString()}`;
              } else return getSingleEntityUrl(result.projectId);
            },
            message: 'Great! New project has been successfully created!',
          }}
        />
      )}
      {currentStep === 2 && (
        <ProjectToolsForm
          projectId={toolsProjectState.projectId}
          relatedProjectId={toolsProjectState.relatedProjectId}
          afterSubmit={{
            execute: result =>
              result.successPassed
                ? patchProjectInfo(toolsProjectState.projectId, {
                    toolsInitState: PROJECT_STATE.COMPLETED,
                  }).then(() => navigate(getSingleEntityUrl(toolsProjectState.projectId)))
                : undefined,
          }}
        />
      )}
    </>
  );
};

export default CreateProjectLayout;
